<template>
	<div class="panel__wrapper panel__wrapper__result">
		<div class="panel__inner">
			<div class="panel__body">
				<div class="panel__header" v-if="icon">
					<div class="panel__icon">
						<img
							:src="
								BASE_URL +
								'images/' +
								icon
							"
							alt=""
						/>
					</div>
				</div>
				<div
					class="panel__title"
					v-if="title"
					v-html="title"
				></div>
				<div class="panel__description">
					{{ description }}
				</div>
			</div>

			<div class="panel__footer">
				<div class="panel__cta">
					<a
						href="https://loja.spcbrasil.org.br/certificado-digital"
						class="button"
						>Ir para loja</a
					>
					<a
						:href="
							BASE_URL +
							link_saiba_mais
						"
						class="button__text"
						>Saiba mais</a
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "CertificadosItemVertical",
	props: ["icon", "title", "description", "link_loja", "link_saiba_mais"],
	data: () => {
		return {
			BASE_URL: process.env.BASE_URL,
		};
	},
};
</script>
